// Freedomly Oy's own details, printed on receipts and shown in the invoicing
// modal (downloadable receipts spec §5.4). CommonJS: shared by server and client.
const FREEDOMLY = {
  name: 'Freedomly Oy',
  street: 'Lapinlahdenkatu 16',
  postalCode: '00180',
  city: 'Helsinki',
  country: 'FI',
  businessId: '3150366-3',
  vatNumber: 'FI31503663',
  email: 'hello@freedomly.io',
  invoiceContactPerson: 'Miikka Salminen',
  eInvoiceAddress: '003731503663',
  eInvoiceOperatorId: 'OKOYFIHH',
};

module.exports = { FREEDOMLY };
